import { render, staticRenderFns } from "./PCurrencyInput.vue?vue&type=template&id=5b720b69&scoped=true&"
import script from "./PCurrencyInput.vue?vue&type=script&lang=js&"
export * from "./PCurrencyInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b720b69",
  null
  
)

export default component.exports